<template>
  <detailTemplate :classCustom="'detail-docs detail-quanTri'">
    <template #content>
      <div class="back-icon border-radius__50 clickable flex-row flex__center">
        <i @click="backModel" class="el-icon-back font-size__large"></i>
      </div>
      <div class="header flex-row flex__left">
        <h4 class="title-name titleSidePanel">Thông tin chi tiết</h4>
      </div>

      <VuePerfectScrollbar
        class="scroll-area"
        :settings="perfectScrollbarSetting"
      >
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          inline-message
          label-position="left"
          label-width="0"
        >
          <VuePerfectScrollbar
            class="scroll-area"
            :settings="{ maxScrollbarLength: 750 }"
          >
            <div class="body">
              <el-collapse v-model="activeTab">
                <div class="group__info">
                  <div class="title font-size__medium">
                    THÔNG TIN SỔ VĂN BẢN
                  </div>
                  <div class="content">
                    <div class="form-input">
                      <el-form-item class="custom-label__input" prop="bookName">
                        <span class="label-input">Tên sổ văn bản: </span>
                        <el-input
                          v-model="form.bookName"
                          size="medium"
                          class="input-detail__editable style-fullWidth input-border__bottom input-border__radius__0"
                          maxlength="100"
                          @input="isFormDataChanged = true"
                        />
                      </el-form-item>
                      <el-form-item
                        class="custom-label__input"
                        prop="prefix"
                        v-if="bookType == BOOK_TYPE.VB_DI"
                      >
                        <span class="label-input">Số ký hiệu: </span>
                        <el-input
                          v-model="form.prefix"
                          size="medium"
                          class="input-detail__editable style-fullWidth input-border__bottom input-border__radius__0"
                          maxlength="100"
                          @input="isFormDataChanged = true"
                        />
                      </el-form-item>
                      <el-form-item
                        class="custom-label__input"
                        prop="bookCurrentNumber"
                      >
                        <span class="label-input">Số hiện tại: </span>
                        <el-input-number
                          class="style-fullWidth"
                          v-model="form.bookCurrentNumber"
                          size="medium"
                          placeholder="-"
                          :controls="true"
                          :min="0"
                          :step="1"
                          :precision="0"
                          :max="100000"
                          @focus="isFormDataChanged = true"
                        ></el-input-number>
                      </el-form-item>
                      <el-form-item class="custom-label__input" prop="status">
                        <span class="label-input">Trạng thái</span>
                        <el-checkbox
                          :border="false"
                          v-model="form.status"
                          @change="statusChanged"
                          class="style-fullWidth"
                        >
                          Hoạt động
                        </el-checkbox>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div
                  class="flex-row flex__left"
                  style="align-items: flex-start"
                  v-if="bookType == BOOK_TYPE.VB_DI"
                >
                  <el-col :span="24" class="margin-right-10">
                    <div class="group__info">
                      <div class="title font-size__medium">
                        TÊN VÀ KÍ HIỆU VĂN BẢN
                      </div>
                      <div class="content">
                        <div class="flex-col width__100">
                          <template>
                            <el-table
                              :data="bookDocTypes"
                              stripe
                              :show-header="
                                bookDocTypes && bookDocTypes.length
                                  ? true
                                  : false
                              "
                              size="medium"
                              style="width: 100%"
                            >
                              <el-table-column
                                label="Loại văn bản"
                                show-overflow-tooltip
                              >
                                <template slot-scope="scope">
                                  <div
                                    class="margin-0 padding-0"
                                    @click="editBookDocType(scope.row)"
                                  >
                                    <div class="font-size__medium">
                                      {{ scope.row.docTypeName }}
                                    </div>
                                  </div>
                                </template>
                              </el-table-column>
                              <el-table-column
                                label="Ký hiệu văn bản"
                                show-overflow-tooltip
                              >
                                <template slot-scope="scope">
                                  <div
                                    class="margin-0 padding-0"
                                    @click="editBookDocType(scope.row)"
                                  >
                                    <div class="font-size__medium">
                                      <span class="font-size__small padding-0">
                                        {{ scope.row.prefix }} &nbsp;
                                      </span>
                                    </div>
                                  </div>
                                </template>
                              </el-table-column>
                              <el-table-column
                                header-align="center"
                                align="center"
                                width="120"
                              >
                                <template slot-scope="scope">
                                  <el-tooltip
                                    :content="
                                      scope.row.status == 1
                                        ? 'Hoạt động'
                                        : 'Không hoạt động'
                                    "
                                    placement="top"
                                  >
                                    <el-button
                                      class="btn-small"
                                      :type="
                                        scope.row.status == 1 ? 'success' : ''
                                      "
                                      plain
                                      size="medium"
                                      @click="updateBookStatus(scope.row)"
                                    >
                                      <span class="flex-row flex__center">
                                        <i
                                          class="fas fa-check font-size__small"
                                        ></i>
                                      </span>
                                    </el-button>
                                  </el-tooltip>
                                </template>
                              </el-table-column>
                            </el-table>
                          </template>

                          <div class="flex-row flex__left">
                            <el-button
                              size="medium"
                              class="addDocs btn-none__border color__white bg__blue margin-top-10"
                              @click="addBookType"
                            >
                              <i class="fas fa-plus-circle"></i>
                              &nbsp;Thêm kí hiệu
                            </el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </div>
                <!--              </el-collapse-item>-->
              </el-collapse>
            </div>
          </VuePerfectScrollbar>
        </el-form>
      </VuePerfectScrollbar>

      <div class="footer">
        <div class="flex-row flex__left form-button__action">
          <el-button
            size="mini"
            class="addDocs btn-none__border color__white bg__blue"
            @click="update"
            :disabled="!isFormDataChanged"
          >
            <i class="fas fa-pen"></i>
            &nbsp;Cập nhật
          </el-button>
          <el-button
            size="mini"
            class="btn__delete btn-none__border color__white bg__red"
            @click="delete_"
          >
            <i class="fas fa-trash"></i>
            &nbsp;Xóa
          </el-button>
        </div>
        <create-book-doc-type-dialog
          :isOpen="isOpenAddDialog"
          :bookId="id"
          :id="selectedBookDocType ? selectedBookDocType.id : null"
          :docTypeSelected="bookDocTypes"
          v-if="isEnableAddBookDocViewDialog"
          @closed="isOpenAddDialog = false"
          @closeDialog="isOpenAddDialog = false"
          @success="createBookDocType"
        />
      </div>
    </template>
  </detailTemplate>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import dateFormatter from "../../filters/dateFormatter";
import constants from "../../constants";
import bookService from "../../services/bookService";
import handleRequestErrorMixin from "../handleRequestErrorMixin";
import goBackMixin from "../../mixins/goBackMixin";
import bookDocTypeService from "../../services/bookDocTypeService";
import CreateBookDocTypeDialog from "./createBookDocType";

export default {
  name: "quanLySoDetail",
  mixins: [handleRequestErrorMixin, goBackMixin],
  filters: { dateFormatter },
  components: {
    CreateBookDocTypeDialog,
    detailTemplate: () => import("../common/detail.vue"),
    Multiselect: () => import("vue-multiselect"),
    VuePerfectScrollbar,
  },

  data() {
    return {
      BOOK_TYPE: constants.BOOK_TYPE,
      bookDetail: null,
      users: null,
      bookDocTypes: [],
      selectedBookDocType: null,
      checkedUserDeptRoleId: null,
      isFormDataChanged: false,

      form: {
        bookName: null,
        prefix: null,
        bookCurrentNumber: null,
        status: null,
      },

      rules: {
        bookName: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur",
          },
        ],
        prefix: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur",
          },
        ],
      },

      USERS: constants.USERS,
      USER_DEPT_ROLE: constants.USER_DEPT_ROLE,
      isEnableAddBookDocViewDialog: false,
      isOpenAddDialog: false,
      activeTab: ["1", "2"],
      perfectScrollbarSetting: { maxScrollbarLength: 350 },
    };
  },

  computed: {
    bookType() {
      return parseInt(this.$route.params.bookType);
    },
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
    id() {
      return this.$route.params.id;
    },
    // isFormDataChanged: {
    //   get: function () {
    //     return (
    //       this.form &&
    //       this.bookDetail &&
    //       (this.form.bookName !== this.bookDetail.bookName ||
    //         this.form.prefix !== this.bookDetail.prefix ||
    //         this.form.bookCurrentNumber !== this.bookDetail.bookCurrentNumber)
    //     );
    //   },
    // },
  },

  watch: {
    isOpenAddDialog(newValue) {
      newValue && (this.isEnableAddBookDocViewDialog = newValue);
    },

    id() {
      this.loadBookDetail();
      this.loadBookDocType();
      this.$refs.form.clearValidate();
      this.selectedBookDocType = null;
      this.isFormDataChanged = false;
    },
  },

  created() {
    this.loadBookDetail()
      .then(() => this.loadBookDocType())
      .then(() => this.bindBookDetail(this.bookDetail));
  },

  methods: {
    addBookType() {
      this.selectedBookDocType = null;
      this.isOpenAddDialog = true;
    },

    backModel() {
      this.goBack();
    },

    editBookDocType(bookDocType) {
      this.selectedBookDocType = bookDocType;
      this.isOpenAddDialog = true;
    },

    updateBookStatus(bookDocType) {
      var statusLabel =
        bookDocType.status == 0 ? "Hoạt đông" : "Không hoạt động";

      this.$confirm(
        `Bạn có muốn thay đổi trạng thái sổ thành '${statusLabel}' không?`,
        "Cảnh báo",
        {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Hủy",
          type: "warning",
        }
      ).then(() => {
        bookDocTypeService
          .activeOrDeactive(bookDocType.id)
          .then(() => {
            this.$message({
              message: "Cập nhật trạng thái sổ thành công",
              type: "success",
            });
            this.loadBookDocType();
          })
          .catch((error) => this.commonHandleRequestError(error));
      });
    },

    createBookDocType(event) {
      this.isOpenAddDialog = false;
      this.loadBookDocType();
    },

    loadBookDocType() {
      return bookService.findAllBookDocTypeByDocId(this.id).then((response) => {
        this.bookDocTypes = response.data;
      });
    },

    bindDataToForm(users) {
      this.form.userName = users.userName;
      this.form.fullName = users.fullName;
      this.form.mobile = users.mobile;
      this.form.email = users.email;
      this.form.mobileSigner = users.mobileSigner;
      this.form.birthDate = users.birthDate ? new Date(users.birthDate) : null;
      this.form.status = users.status;
    },

    bindBookDetail() {
      let bookInfo = this.bookDetail;
      this.form.bookName = bookInfo.bookName;
      this.form.prefix = bookInfo.prefix;
      this.form.bookCurrentNumber = bookInfo.bookCurrentNumber;
      this.form.status =
        bookInfo.vbBookStatus === constants.VB_BOOK.STATUS.ACTIVE;
    },

    loadBookDetail() {
      return bookService
        .findById(this.id)
        .then((response) => (this.bookDetail = response.data));
    },

    backListPage() {
      this.$router.back();
    },

    delete_() {
      this.$confirm(
        "Bạn có muốn xóa sổ '" + this.bookDetail.bookName + "'",
        "Thông báo",
        {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Hủy bỏ",
          type: "warning",
        }
      ).then(() => {
        bookService
          .delete(this.id)
          .then(() => {
            this.$message({
              message: "Xóa xổ thành công",
              type: "success",
            });
            this.notifyMasterForDataChange(null);
            this.goBack();
          })
          .catch((error) => this.commonHandleRequestError(error));
      });
    },

    update() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        let submitForm = {
          bookName: this.form.bookName,
          bookType: this.bookType,
          prefix: this.form.prefix,
          bookCurrentNumber: this.form.bookCurrentNumber,
        };
        bookService
          .edit(this.id, submitForm)
          .then((response) => {
            this.bookDetail = response.data;
            this.isFormDataChanged = false;
            this.$message({
              message: "Cập nhật thông tin sổ thành công",
              type: "success",
            });
            this.notifyMasterForDataChange({ vbBook: this.bookDetail });
            this.goBack();
          })
          .catch((error) => this.commonHandleRequestError(error));
      });
    },

    statusChanged() {
      let statusLabel = this.form.status ? "Hoạt động" : "Không hoạt động";
      this.$confirm(
        `Bạn có muốn cập nhật trạng thái của sổ thành ${statusLabel} không ?`,
        "Thông báo",
        {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Hủy bỏ",
          type: "warning",
        }
      )
        .then(() => {
          let submitForm = {
            status: this.form.status
              ? constants.VB_BOOK.STATUS.ACTIVE
              : constants.VB_BOOK.STATUS.DEACTIVE,
          };
          bookService
            .changeStatus(this.id, submitForm)
            .then((response) => {
              this.bookDetail = response.data;
              this.$message({
                message: "Cập nhật trạng thái sổ thành công",
                type: "success",
              });
              this.notifyMasterForDataChange({ vbBook: this.bookDetail });
            })
            .catch((error) => {
              this.form.status = !this.form.status;
              return this.commonHandleRequestError(error);
            });
        })
        .catch(() => {
          this.form.status = !this.form.status;
        });
    },
  },
};
</script>

<style scoped>
/*.detail-quanTri {*/
/*  min-width: 700px;*/
/*}*/

.btn-small {
  border-radius: 50%;
  display: inline-flex;
  padding: 5px;
  justify-content: center;
  align-items: center;
}

.group__info {
  margin: 12px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/book/Detail.vue